import React from "react";
import { motion } from "framer-motion";
import { useT } from "../i18n/LanguageContext";

const RESERVE_URL = "https://pnssm.pro/5sq02s5";

/**
 * Reusable mid-page CTA band — pulsante "Prenota il tuo giovedì"
 * tone: "noir" (default, bg nero caldo) | "wine" (bg vinaccia) | "transparent"
 */
export const CTABand = ({ tone = "noir", testId = "cta-band" }) => {
  const { t } = useT();
  const bgClass =
    tone === "wine" ? "bg-wine" :
    tone === "transparent" ? "" :
    "bg-noir";

  return (
    <section
      className={`relative ${bgClass} py-14 md:py-20 px-6 md:px-10 text-center overflow-hidden`}
      data-testid={testId}
    >
      <div className="absolute inset-0 grain pointer-events-none opacity-40" />
      <motion.div
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.9, ease: [0.22, 0.61, 0.36, 1] }}
        className="relative inline-flex flex-col items-center gap-2"
      >
        <a
          href={RESERVE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="cta-primary !text-[17px] md:!text-[19px] !py-[22px] !px-[44px]"
          data-testid={`${testId}-link`}
        >
          {t.hero.ctaReserve}
          <span aria-hidden>→</span>
        </a>
      </motion.div>
    </section>
  );
};
